import { jsx as i } from "react/jsx-runtime";
import e from "./IconBase.js";
import { getIconColor as t, mapChildren as a, getViewBox as o, deprecatedIconsMap as r } from "./utils.js";
import { iconData as n } from "./icon-data.js";
var s = function s(_s) {
  var l;
  var d = _s.ariaHidden,
    u = _s.size,
    c = _s.surface,
    m = _s.id,
    f = _s.name,
    v = _s.title,
    p = _s.ariaLabel,
    j = function () {
      var i = f;
      if (Object.keys(r).includes(i)) {
        var _e = r[i];
        return null == n ? void 0 : n[_e];
      }
      return null == n ? void 0 : n[i];
    }(),
    b = t(_s);
  return j ? i(e, {
    ariaHidden: d,
    color: b,
    id: m,
    name: f,
    size: u,
    surface: c,
    svgContent: a(j.c, b),
    title: v,
    viewBox: o(null === (l = j.a) || void 0 === l ? void 0 : l.v),
    ariaLabel: p
  }) : null;
};
s.defaultProps = {
  size: "medium",
  surface: "light",
  ariaHidden: !1,
  title: void 0
}, s.displayName = "VDS_Icon";
export { s as default };